<template>
  <div :class="$style.footer">
    <div :class="$style.page">
      <em>{{ getPage(index + 1) }}</em>
      /
      {{ getPage(total) }}
      <span>{{ title }}</span>
    </div>
    <div :class="$style.scroll">
      <div :class="$style.scroll_bar">
        <div :style="{ width: barWidth }"></div>
      </div>
      <button :class="$style.scroll_prev" @click="onChange('prev')" />
      <button :class="$style.scroll_next" @click="onChange('next')" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    title: { type: String, default: '' },
  },
  computed: {
    barWidth() {
      return `${Math.round(((this.index + 1) / this.total) * 100)}%`
    },
  },
  methods: {
    getPage(page) {
      return page < 10 ? `0${page}` : page
    },
    onChange(type) {
      this.$emit('change', type)
    },
  },
}
</script>

<style lang="less" module>
@arrow-width: 0.26rem;
@arrow-hegith: 0.27rem;

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.38rem;
}

.page {
  color: #a0a0a0;

  em {
    font-size: 0.32rem;
    color: @primary;
  }

  span {
    display: inline-block;
    margin-left: 0.5rem;
    white-space: nowrap;
  }
}

.scroll {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &_bar {
    .size(5.11rem, 2px);
    background-color: #a0a0a0;

    > div {
      height: 100%;
      background-color: @primary;
      transition: width 0.3s;
    }
  }

  &_prev,
  &_next {
    .size(@arrow-width, @arrow-hegith);
    background: url('./images/day-footer-arrow.png') no-repeat;
    background-size: 200% 200%;

    &:hover {
      background-color: @primary;
    }
  }

  &_prev {
    margin-left: 0.48rem;
    background-position: 0 0;

    &:hover {
      background-position: 0 100%;
    }
  }

  &_next {
    margin-left: 0.3rem;
    background-position: 100% 0;

    &:hover {
      background-position: 100% 100%;
    }
  }
}

@media screen and (max-width: @tablet-width) {
  .page {
    em {
      font-size: 18px;
    }
  }

  .scroll {
    &_prev,
    &_next {
      .size(@arrow-width * 1.5, @arrow-hegith * 1.5);
    }
  }
}

@media screen and (max-width: @mini-width) {
  .scroll {
    &_bar {
      display: none;
    }

    &_prev,
    &_next {
      .size(@arrow-width * 2.5, @arrow-hegith * 2.5);
    }

    &_prev {
      margin-left: 0;
    }

    &_next {
      margin-left: @arrow-width * 2.5;
    }
  }
}

@media screen and (max-width: @mobile-width) {
  .footer {
    font-size: 12px;
  }

  .page {
    em {
      font-size: 16px;
    }
  }

  .scroll {
    &_prev,
    &_next {
      .size(@arrow-width * 3, @arrow-hegith * 3);
    }

    &_next {
      margin-left: @arrow-width * 3;
    }
  }
}
</style>
